import "./Footer.css";
import { Link } from "react-router-dom";
import adflynLogo from "../../assets/logo/adflynLogo.png";
import linkedin from "../../assets/icons/linkedin.png";
import instagram from "../../assets/icons/instagram.png";
import whatsapp from "../../assets/icons/whatsapp.png";
import discord from "../../assets/icons/discord.png";



const FooterLink = ({ children, href }) => (
  <a href={href} className="footer-link" target="_blank" rel="noopener noreferrer">{children}</a>
);

const SocialIcon = ({ src, alt, href }) => (
  <a href={href} className="social-icon" target="_blank" rel="noopener noreferrer">
    <img 
      src={src} 
      alt={alt} 
      className="social-icon-img" 
      onError={(e) => e.target.src='https://placehold.co/20x20/ccc/333?text=Icon'} 
    />
  </a>
); 
const AdflynLogoFooter = () => (
  <Link to="/" className="logo-section" style={{gap: '0.25rem', textDecoration: 'none'}}>
    <img src={adflynLogo} alt="Logo" className="adflyn-logo-footer" />
  </Link>
);
export function Footer() {
  return (
      <footer className="footer-container">
        <div className="footer-content-wrapper">
          <div className="footer-top">
            <AdflynLogoFooter />
            <div className="footer-col-wrapper">
              <div className="footer-col">
                <div className="footer-title">Terms & Conditions</div>
                <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
                <Link to="/cookie-policy" className="footer-link">Cookie Policy</Link>
              </div>
              
              <div className="footer-col">
                <div className="footer-title">Social</div>
                <div className="social-icons">
                  <SocialIcon src={linkedin} alt="Linkedin" href="https://www.linkedin.com/company/adflyn/?viewAsMember=true" />
                  <SocialIcon src={instagram} alt="Instagram" href="https://www.instagram.com/adflyn_com?igsh=ZzBuMzJrc3IyaG5y" />
                  <SocialIcon src={whatsapp} alt="WhatsApp" href="https://chat.whatsapp.com/E1shYFx6vfOBdzInqwbJt6" />
                  <SocialIcon src={discord} alt="Discord" href="https://discord.gg/Mh7EywuY" />
                </div>
              </div>
            </div>
          </div>
          
          <div className="footer-bottom">
            <p>© Copyright Adflyn Technologies PVT LTD. All Rights Reserved.</p>
            <div className="footer-made-with">
              <p>Made with ❤️ from 🇮🇳</p>
            </div>
          </div>
        </div>
      </footer>
  );
}

export default Footer;